// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const B2E_DOMAIN = 'ross-applications-i.eu-central-1.aws.cloud.bmw';
const B2D_DOMAIN = 'ross-applications-i.aws.bmw.cloud';
const domain = window.location.hostname;
export const environment = {
  production: false,

  b2e: {
    serverURL:
      'https://ross-applications-i.eu-central-1.aws.cloud.bmw/api/ross/icd/v1',
    oauthDomainURL: 'https://auth-i.bmwgroup.net',
    issuer:
      'https://auth-i.bmwgroup.net:443/auth/oauth2/realms/root/realms/intranetb2x',
    redirectUri: 'https://ross-applications-i.eu-central-1.aws.cloud.bmw',
    clientId: '5c2caf8f-ffae-46cf-95db-1bf5dbb5dab8',
    responseType: 'code',
    scope: 'openid profile email bmwids organization b2xroles',
    loginUrl:
      'https://auth-i.bmwgroup.net:443/auth/oauth2/realms/root/realms/intranetb2x/authorize',
    requireHttps: true,
    oidc: true,
    showDebugInformation: true,
    userType: 'B2E',
    env: 'INT',
    acr_values: 'strongAuth4000Service',
  },
  b2d: {
    serverURL: 'https://ross-applications-i.aws.bmw.cloud/api/ross/icd/v1',
    oauthDomainURL: 'https://auth-i.bmwgroup.com',
    issuer:
      'https://auth-i.bmwgroup.com:443/auth/oauth2/realms/root/realms/internetb2x',
    redirectUri: 'https://ross-applications-i.aws.bmw.cloud',
    clientId: 'a8caaec2-d9cd-4b45-9d60-7aa73d70db53',
    responseType: 'code',
    scope: 'openid profile email bmwids organization b2xroles b2d',
    loginUrl:
      'https://auth-i.bmwgroup.com:443/auth/oauth2/realms/root/realms/internetb2x/authorize',
    requireHttps: true,
    oidc: true,
    showDebugInformation: true,
    userType: 'B2D',
    env: 'INT',
    acr_values: 'strongAuth4000Service',
  },

  domain: domain,
  domainType: domain.includes(B2E_DOMAIN) ? 'b2e' : 'b2d',
  isB2D: domain.includes(B2D_DOMAIN),
  isB2E: domain.includes(B2E_DOMAIN),
};

console.log('current environment ', environment);
